<kl-grid
  [columns]="[
    { header: 'code' | translate, binding: 'code', width: 150, visible: true },
    {
      header: 'title' | translate,
      binding: 'description',
      width: '*',
      visible: true
    }
  ]"
  [filterable]="true"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [service]="{
    service: 'current-account',
    name: 'current_accounts',
    filterChild: 'flat',
    form: 'CURRENT_ACCOUNT',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'FINANCE_MANAGEMENT'"
  [moduleName]="'CURRENT_ACCOUNT_LIST'"
  [gridName]="'grdCurrentAccountList'"
  [customFilter]="true"
  [dblSelect]="dblSelect"
  [filterSelectItems]="filterSelectItems"
  [customFilterOutlet]="'CURRENT_ACCOUNT_DETAIL_FILTER'"
  (onCloseAlert)="alertShow = false"
>
</kl-grid>
